import {ImportContainer} from "../../Model/dataProcess/importContainer";
import {Injectable} from "@angular/core";
import {GenericService} from "../generic/genericRepository.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {lastValueFrom} from "rxjs";
import {DataProcessContainer} from "../../Model/dataProcess/dataprocesscontainer";
import {Catalog} from "../../Model/Catalog/Catalog";

export interface ComparisonCounts {
  total: number;
  neu: number;
  geaendert: number;
  geloescht: number;
}

@Injectable()
export class ImportContainerService extends GenericService<ImportContainer> {

  constructor(http: HttpClient) {
    super(http);
    this.apiUrl = "api/ImportContainer";
  }

  public getContainerCatalogsByImportContainerId(id: string, customerId: string): Promise<Catalog[]> {
    const url = `${this.apiUrl}/getContainerCatalogsByImportContainerId`;
    const params = new HttpParams().append('importContainerId', id).append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.get<Catalog[]>(url, options));
  }
  
  public deleteContainerCatalogsByCatalogId(removedCatlogId: string, customerId: string): Promise<Catalog[]> {
    const url = `${this.apiUrl}/deleteContainerCatalogsByCatalogId`;
    const params = new HttpParams().append('removedCatalogId', removedCatlogId).append('customerId', customerId);
    const options = {params};
    return lastValueFrom(this.http.delete<Catalog[]>(url, options));
  }

  public updateDropZones(importContainerId: string, activeCatalogId: string | null, compareCatalogId: string | null, customerId: string): Promise<void> {
    const url = `${this.apiUrl}/updateDropZones`;
    let params = new HttpParams()
      .append('importContainerId', importContainerId)
      .append('customerId', customerId);
    if (activeCatalogId) {
      params = params.append('activeCatalogId', activeCatalogId);
    }
    if (compareCatalogId) {
      params = params.append('compareCatalogId', compareCatalogId);
    }
    return lastValueFrom(this.http.post<void>(url, null, { params }));
  }

  public getComparisonCounts(catalogId: string, customerId: string): Promise<ComparisonCounts> {
    const url = `${this.apiUrl}/getComparisonCounts`;
    const params = new HttpParams().append('catalogId', catalogId).append('customerId', customerId);
    return lastValueFrom(this.http.get<ComparisonCounts>(url, {params}));
  }

  public getAllDataSourceTags(customerId: string): Promise<string[]> {
    const url = `${this.apiUrl}/getAllDataSourceTags`;
    const params = new HttpParams().append('customerId', customerId);
    return lastValueFrom(this.http.get<string[]>(url, {params}));
  }

  public deleteByContainerId(removedCatlogId: string,containerCreatedByUserId: string, customerId: string ): Promise<Catalog[]> {
    const url = `${this.apiUrl}/deleteByContainerId`;
    const params = new HttpParams().append('removedContainerId', removedCatlogId).append('customerId', customerId).append('containerCreatedByUserId',containerCreatedByUserId);
    const options = {params};
    return lastValueFrom(this.http.delete<Catalog[]>(url, options));
  }
  
}
